import api  from '../../../../configs/api'
import Form from '../../../../display/forms/FormElements'

const elements =
[
    {
        type : Form.TEXTFIELD ,
        init :
        {
            id           : 'name',
            label        : 'Nom de l\'article',
            autoFocus    : true,
            fullWidth    : true,
            helperText   : 'Obligatoire',
            margin       : 'normal',
            required     : true,
            select       : false,
            autoComplete : 'off' ,
            type         : 'text',
            variant      : 'outlined'
        }
    },
    {
        type : Form.SEARCH_SELECTOR ,
        path : api.thesaurus.articles_types ,
        init :
        {
            id         : 'additionalType',
            key        : 'additionalType',
            label      : 'Type d\'article',
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            required   : true,
            type       : 'text',
            variant    : 'outlined'
        },
        selector : { i18n :
        {
            empty       : 'Aucun type disponible.' ,
            title       : 'Sélectionner un type',
            description : 'Veuillez sélectionner un type d\'article ci-dessous.' ,
        }}
    },
];

export default
{
    add :
    {
        elements,
        agree       : 'Créer' ,
        disagree    : 'Annuler' ,
        title       : 'Ajouter un article' ,
        description : 'Veuillez remplir le formulaire ci-dessous pour créer une nouvelle fiche.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en  cours...' ,
        success     : 'Ajout du nouvel enregistrement réussi!'
    },
    remove :
    {
        agree        : 'Supprimer' ,
        description  : 'Souhaitez-vous supprimer l\'enregistrement :' ,
        descriptionX : 'Souhaitez-vous supprimer les {0} enregistrements :' ,
        disagree     : 'Annuler' ,
        loading      : 'Suppression en cours...' ,
        title        : 'Supprimer cet article ?',
        titleX       : 'Supprimer des articles ?'
    }
};
